// extracted by mini-css-extract-plugin
export default {"messageItem":"index_messageItem__uA7Bu","error":"index_error__ufnPG","success":"index_success__G6CDC","content":"index_content__ydo4f"};